/**
 * CustomTablesSection — renders the super-admin custom output tables (scan
 * sheets) for a given placement (below the BOM or below the placement guide).
 * Shared by EstimateResults (wizard) and SharedEstimate.
 */

import React from 'react';
import { EstimateOutput } from '../../types';
import { buildCustomTables, RenderCtx } from '../../utils/renderModel';
import { getCustomTables, getCustomFieldsForProduct } from '../../data/productTable';
import { CustomBlockTable } from './CustomBlockTable';

interface Props {
  estimate: EstimateOutput;
  placement: 'belowBom' | 'belowPlacement';
}

export const CustomTablesSection: React.FC<Props> = ({ estimate, placement }) => {
  const ctx: RenderCtx = { currency: 'USD', showPrices: false, getFields: getCustomFieldsForProduct };
  const tables = buildCustomTables(getCustomTables(), estimate, ctx, placement);
  if (tables.length === 0) return null;
  return (
    <>
      {tables.map((t) => (
        <CustomBlockTable key={t.key} table={t} />
      ))}
    </>
  );
};

export default CustomTablesSection;
